import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AlertController, ModalController } from '@ionic/angular';
import { Playlist } from 'src/app/models/playlist';
import { SeachHelper } from 'src/app/models/searchHelper';
import { Song, SongModel } from 'src/app/models/songModel';
import { StreamState } from 'src/app/models/streamState';
import { HttpService } from 'src/app/services/http/http.service';
import { MobileService } from 'src/app/services/mobile/ios.service';
import { OfflineService } from 'src/app/services/offline/offline.service';
import { PlayerService } from 'src/app/services/player/player.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-player-modal',
  templateUrl: './player-modal.component.html',
  styleUrls: ['./player-modal.component.scss'],
})
export class PlayerModalComponent implements OnInit {
  @Input() player: PlayerService;
  @Input() song: Song;
  state: StreamState;
  public static searchHelper: SeachHelper = {};
  progressValue: number;
  playbackValue: number = 1;
  isRepeatModeEnabled = false;
  isShuffleModeEnabled = false;
  @Input() songList: Song[];
  actionSelected = null;
  newPlaylist: Playlist = new Playlist();
  playlists: Playlist[] = [];
  isModalOpen = false;


  constructor(
    private modalController: ModalController,
    private storage: StorageService,
    private http: HttpService,
    private alertController: AlertController,
    private offlineService: OfflineService,
    public mobileService: MobileService,
    private sanitizer: DomSanitizer
  ) {
    setTimeout(() => {
      this.player.getState()
      .subscribe(state => {
        this.state = state;
        this.progressValue = (this.state.currentTime / this.state.duration);
        if(this.state.playbackRate){
          this.playbackValue = this.state.playbackRate;
        }
      });
      this.playbackValue = localStorage.getItem('playbackRate') ? parseFloat(localStorage.getItem('playbackRate')) : 1;
    }, 0);
  }

  getCoverSrc(cover: string | undefined): SafeUrl | string {
    if (cover?.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(cover);
    }
    return cover || 'assets/default_cover.jpeg';
  }

  ngOnInit() {
    const isShuffleModeEnabled = localStorage.getItem('shuffleMode');
    if (isShuffleModeEnabled && isShuffleModeEnabled === 'true') {
      this.isShuffleModeEnabled = true;
    }

    const isRepeatModeEnabled = localStorage.getItem('repeatMode');
    if (isRepeatModeEnabled && isRepeatModeEnabled === 'true') {
      this.isRepeatModeEnabled = true;
    }

    this.player.songList.subscribe((data)=>{
      this.songList = data;
    });

    this.loadPlaylists();
   }

  close() {
    this.modalController.dismiss({
      selectedSong: this.player.song,
      playback: this.playbackValue
    });
  }

  play() {
    this.player.play();
  }

  pause() {
    this.player.pause();
  }

  async next() {
    const playback = this.playbackValue;
    const isShuffleModeEnabled = localStorage.getItem('shuffleMode');
    if (isShuffleModeEnabled && isShuffleModeEnabled === 'true') {
      const song = await this.getRandomTrack();
      this.openSong(song);
      await this.openFile(song);
      this.player.playbackRate(playback);
      this.play();
    } else {
      const index = this.songList.lastIndexOf(this.player.song) + 1;
      if (index == this.songList.length - 2) {
        this.player.loadNextPage.next(true);
      }
      const file = this.songList[index];
      this.player.song = file;
      await this.openFile(file);
      this.player.playbackRate(playback);
      this.player.play();
    }
  }
  async previous() {
    const playback = this.playbackValue;
    const isShuffleModeEnabled = localStorage.getItem('shuffleMode');
    if (isShuffleModeEnabled && isShuffleModeEnabled === 'true') {
      const song = await this.getRandomTrack();
      this.openSong(song);
      await this.openFile(song);
      this.player.playbackRate(playback);
      this.play();
    } else {
      const index = this.songList.lastIndexOf(this.player.song) - 1;
      const file = this.songList[index];
      this.player.song = file;
      await this.openFile(file);
      this.player.playbackRate(playback);
      this.player.play();
    }

  }

  getRandomTrack(): Promise<Song> {
    if (this.offlineService.isOffline$.value) {
      const randomIndex = Math.floor(Math.random() * this.songList.length);
      return Promise.resolve(this.songList[randomIndex]);
    }
    PlayerModalComponent.searchHelper.disciplines = [this.songList[0].discipline.id];
    PlayerModalComponent.searchHelper.dances = [this.songList[0].dance.id];
    let tags = null;
    try {
      tags = this.storage.getItem('tags');
    } catch (e) {
      tags = null;
    }
    if (tags && tags !== undefined && tags.length > 0) {
      PlayerModalComponent.searchHelper.tags = tags;
    }
    if (this.songList[0].playlist_id) {
      PlayerModalComponent.searchHelper.playlist = this.songList[0].playlist_id;
    }
    if (this.player.song) {
      PlayerModalComponent.searchHelper.currentSong = this.player.song.id;
    }
    return this.http.getRandomTrack(PlayerModalComponent.searchHelper);
  }

  isFirstPlaying() {
    if (this.isShuffleModeEnabled) return false;
    if(this.player.song){
      return this.songList.lastIndexOf(this.player.song) === 0;
    }
    return false;
  }

  isLastPlaying() {
    if (this.isShuffleModeEnabled) return false;
    if(this.player.song){
      return this.songList.lastIndexOf(this.player.song) === this.songList.length - 1;
    }
    return false;
  }

  async openFile(song) {
    this.storage.selectedSong.next(song);
    this.progressValue = 0;
    this.player.stop();
    // this.player.resetCountCheck.next(true);
    const url = await this.player.getPlayableUrl(song, song.stream_url);
    this.player.playStream(url).subscribe(events => {});
  }

  openSong(song) {
    this.player.song = song;
  }

  onRangeChange(event){
    const newVal = event.detail.value;
    if(this.progressValue != newVal){
      const seekToVal = newVal*this.state.duration;
      this.player.seekTo(seekToVal);
    }
  }

  velocityRangeChange(event){
    let newVal = event.detail.value;
    if(this.state.playbackRate != newVal){
      this.player.playbackRate(newVal);
      localStorage.setItem('playbackRate', newVal.toString());
    }
  }

  resetVelocity() {
    let newVal = 1;
    if(this.state.playbackRate != newVal){
      this.player.playbackRate(newVal);
      localStorage.setItem('playbackRate', newVal.toString());
    }
  }

  toggleShuffleMode() {
    this.isRepeatModeEnabled = false;
    this.isShuffleModeEnabled = !this.isShuffleModeEnabled;
    localStorage.setItem('repeatMode', this.isRepeatModeEnabled.toString());
    localStorage.setItem('shuffleMode', this.isShuffleModeEnabled.toString());
  }

  toggleRepeatMode() {
    this.isShuffleModeEnabled = false;
    this.isRepeatModeEnabled = !this.isRepeatModeEnabled;
    localStorage.setItem('shuffleMode', this.isShuffleModeEnabled.toString());
    localStorage.setItem('repeatMode', this.isRepeatModeEnabled.toString());
  }

  async loadPlaylists() {
    // this.playlists = [
    //   {name: 'Playlist', songList: [], id: 1},
    //   {name: 'Playlist 2', songList: [], id: 2}
    // ]
    this.playlists = await this.http.getPlaylists();
  }

  changeActionSelected(action) {
    this.actionSelected = action;
  }

  openPlaylistModal(action) {
    this.changeActionSelected(action);
    this.setOpen(true);
  }

  dismissModal() {
    this.actionSelected = null;
    this.setOpen(false);
  }

  async addSongToPlaylist(playlist: Playlist) {
    this.actionSelected = 'loader';
    if (playlist && this.player.song) {
      const added = await this.http.addSongToPlaylist(this.player.song, playlist);
      if (added) {
        this.actionSelected = 'addedSong';
        // this.startAutocloseModal('addedSong');
      }
    }
    return true;
  }

  async toggleFavorite() {
    if (!this.player.song) {
      return;
    }
    this.actionSelected = 'loader';
    this.setOpen(true);
    if (this.player.song.is_favorite) {
      const result = await this.http.removeSongFromFavorites(this.player.song);
      if (result?.success) {
        this.player.song.is_favorite = false;
        this.actionSelected = 'removedFromFavorites';
        this.startAutocloseModal('removedFromFavorites');
      } else {
        this.actionSelected = 'error';
        this.startAutocloseModal('error');
      }
    } else {
      const result = await this.http.addSongToFavorites(this.player.song);
      if (result?.success) {
        this.player.song.is_favorite = true;
        this.actionSelected = 'addedToFavorites';
        this.startAutocloseModal('addedToFavorites');
      } else {
        this.actionSelected = 'error';
        this.startAutocloseModal('error');
      }
    }
  }

  async downloadSong() {
    this.actionSelected = 'loader';
    this.changeActionSelected(this.actionSelected);
    this.setOpen(true);

    const streamUrl = PlayerService.audioObj.src;
    if (streamUrl && this.player.song) {
      try {
        const blob = await this.http.downloadSong(streamUrl);

        let coverBlob: Blob | null = null;
        if (this.player.song.cover) {
          try { coverBlob = await this.http.downloadSong(this.player.song.cover); } catch { }
        }

        await this.offlineService.saveSong(blob, this.player.song, coverBlob);
        this.actionSelected = 'downloadedSong';
        this.player.song.isDownloaded = true;
      } catch (error) {
        console.error("Errore processo download:", JSON.stringify(error));
        this.actionSelected = 'error';
        this.startAutocloseModal('error');
      }
    }
  }

  async createPlaylist() {
    if (this.newPlaylist) {
      this.actionSelected = 'loader';
      const playlistCreated = await this.http.savePlaylist(this.newPlaylist);
      if (playlistCreated) {
        if (playlistCreated && this.player.song) {
          const added = await this.http.addSongToPlaylist(this.player.song, playlistCreated);
          if (added) {
            this.actionSelected = 'addedSong';
            this.newPlaylist = new Playlist();
            this.startAutocloseModal('addedSong');
          } else {
            this.actionSelected = 'error';
            this.startAutocloseModal('error');
          }
        }
      } else {
        this.actionSelected = 'error';
        this.startAutocloseModal('error');
      }
    }
  }

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }

  startAutocloseModal(currentSelection: string) {
    const current = currentSelection;
    const timeout = setTimeout(() => {
      if (this.isModalOpen && current === this.actionSelected) {
        this.setOpen(false);
      }
    }, 2000)
  }
}
